import React from 'react';
import { Modal } from '../ui/Modal.js';
import { useDataContext } from '../../context/data.js';
import translations from '../../constants/translations.json';

const ValidationErrorModal = ({ isOpen, onClose, validationErrorMessage }) => {
  const { language } = useDataContext();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={translations[language]?.restaurant_menu_required}
      staticBackdrop
    >
      <div className="text-center space-y-2">
        <div className="flex items-start justify-center space-x-2">
          <div className="text-red-500">
            <i className="fas fa-exclamation-circle text-3xl" />
          </div>
          <h3 className="text-base sm:text-lg font-bold whitespace-pre-wrap">
            {validationErrorMessage}
          </h3>
        </div>
        <button
          className="w-full sm:w-[200px] bg-primary hover:bg-secondary text-white font-bold text-sm sm:text-base px-4 py-[12px] rounded-full transition-colors"
          onClick={onClose}
        >
          {translations[language]?.close}
        </button>
      </div>
    </Modal>
  );
};

export default ValidationErrorModal;
